Service = App.loadClass 'core::Angular/Service'

class exports.QBQService extends Service
    constructor: (@http, @rootScope) ->
        undefined

    triggerSync: (type, extra) =>
        return @http.post 'backend/portal/qbq/trigger-sync',
            type: type
            extra: extra

    getQueueData: () =>
        return @http.post 'backend/portal/qbq/get-queue-data'
